import Sidebar from './SideBar.vue';
import SidebarItem from './SidebarItem.vue';
import DashboardLayout from "../../views/Layout/DashboardLayout";

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  breakpoint: 1200,
  hovered: false,
  displaySidebar(value) {
    if (window.innerWidth > this.breakpoint) {
      return;
    }
    this.isMinimized = !value
    this.showSidebar = value;
    let docClasses = document.body.classList;
    if (value) {
      docClasses.add('g-sidenav-pinned')
      docClasses.add('g-sidenav-show')
      docClasses.remove('g-sidenav-hidden')
      document.getElementById('navTop').classList.add('nav-header-reduce')
      document.getElementById('navTop').classList.remove('nav-header-expand')
    } else {
      docClasses.add('g-sidenav-hidden')
      docClasses.remove('g-sidenav-pinned')
      docClasses.remove('g-sidenav-show')
      document.getElementById('navTop').classList.add('nav-header-expand')
      document.getElementById('navTop').classList.remove('nav-header-reduce')
    }
  },
  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
    let docClasses = document.body.classList;
    if (this.isMinimized) {
      docClasses.add('g-sidenav-hidden')
      docClasses.remove('g-sidenav-pinned')
      docClasses.remove('g-sidenav-show');
      document.getElementById('navTop').classList.add('nav-header-expand')
      document.getElementById('navTop').classList.remove('nav-header-reduce')
      document.getElementById('navBottom').classList.add('nav-header-expand')
      document.getElementById('navBottom').classList.remove('nav-header-reduce')
    } else {
      docClasses.add('g-sidenav-pinned')
      docClasses.add('g-sidenav-show')
      docClasses.remove('g-sidenav-hidden');
      document.getElementById('navTop').classList.add('nav-header-reduce')
      document.getElementById('navTop').classList.remove('nav-header-expand')
      document.getElementById('navBottom').classList.add('nav-header-reduce')
      document.getElementById('navBottom').classList.remove('nav-header-expand')
    }
    if (this.hovered) {
      docClasses.add('g-sidenav-show')
    }
  },
  onMouseEnter() {
    this.hovered = true
    if (this.isMinimized) {
      document.body.classList.add('g-sidenav-show')
      document.body.classList.remove('g-sidenav-hidden')
      document.getElementById('collapse-just').classList.remove('collapse-side-not-show')
      document.getElementById('collapse-just1').classList.remove('collapse-side-not-show')
      // document.getElementById('collapse-just2').classList.remove('collapse-side-not-show') // unused?
    }
  },
  onMouseLeave() {
    this.hovered = false
    if (this.isMinimized) {
      let docClasses = document.body.classList
      docClasses.remove('g-sidenav-show')
      docClasses.add('g-sidenav-hide')
      setTimeout(() => {
        docClasses.remove('g-sidenav-hide')
        docClasses.add('g-sidenav-hidden')
        document.getElementById('collapse-just').classList.add('collapse-side-not-show');
        document.getElementById('collapse-just1').classList.add('collapse-side-not-show')
        // document.getElementById('collapse-just2').classList.add('collapse-side-not-show') // unused?
      }, 300)
    }
  }
};

const SidebarPlugin = {
  install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    let app = new Vue({
      data: {
        sidebarStore: SidebarStore
      }
    });
    Vue.prototype.$sidebar = app.sidebarStore;
    Vue.component('side-bar', Sidebar);
    Vue.component('dashboard-layout', DashboardLayout)
    Vue.component('sidebar-item', SidebarItem);
  }
};

export default SidebarPlugin;
